export class SurveySaveModel {
    
    constructor(private questionList: any[],
        private surveyPaperId: string,
        private surveyShareId: string,
        private eaPatientInfoId: string,
        private saId: string, ){}
}